// extracted by mini-css-extract-plugin
export default {"filters":"FQdD_DPa","field":"dPONHGp5"};